<template>
  <div
    id="delivery_type_selector"
    class="tt-delivery-type"
    v-if="allProductsPickupOnly !== null"
  >
    <div class="tt-delivery-type__tabs ff-mont">
      <button
        v-if="!allProductsPickupOnly"
        class="tt-delivery-type__tab"
        :class="{
          'tt-delivery-type__tab--active': isDelivery && !isExpressDelivery,
        }"
        :disabled="!assertDeliveryMinAmount"
        @click="setIsDelivery(true, false)"
      >
        <span v-if="assertDeliveryMinAmount">
          {{ $t("OrderBasket_views_section_tabs_delivery") }}
        </span>
        <span v-else>
          {{ $t("OrderBasket_delivery_min_amount") }}
        </span>
      </button>
      <button
        v-if="canPickup"
        class="tt-delivery-type__tab"
        :class="{ 'tt-delivery-type__tab--active': !isDelivery }"
        @click="setIsDelivery(false, false)"
      >
        {{ $t("OrderBasket_views_section_tabs_samovivoz") }}
      </button>

      <button
        v-if="
          !allProductsPickupOnly &&
          yaStartHour < new Date().getHours() &&
          yaStopHour > new Date().getHours()
        "
        class="tt-delivery-type__tab"
        :class="{
          'tt-delivery-type__tab--active': isDelivery && isExpressDelivery,
        }"
        :disabled="!assertDeliveryMinAmount"
        @click="setIsDelivery(true, true)"
      >
        <span v-if="assertDeliveryMinAmount" class="express-delivery-span">
          <img
            src="@/assets/icons-new/yandex.svg"
            class="express-delivery-logo"
            alt="yandex-logo"
          />
          {{ $t("OrderBasket_views_section_tabs_yandex_express") }}
        </span>
        <span v-else>
          {{ $t("OrderBasket_delivery_min_amount") }}
        </span>
      </button>
    </div>

    <p
      v-if="showPickupUnavailableText"
      class="tt-delivery-type__pickup-hint ff-mont"
    >
      {{
        pickupTabMinAmountStub
          ? $t("OrderBasket_pickup_tab_min_amount_stub")
          : $t("OrderBasket_views_section_tabs_cant_samovivoz")
      }}
    </p>

    <TakeExpressDelivery v-if="isDelivery && isExpressDelivery " />
    <TakeDelivery v-if="isDelivery && !isExpressDelivery" />
    <TakePickup v-else-if="!isDelivery" />
  </div>
</template>

<script>
import { mapState,mapGetters } from "vuex";
import TakeDelivery from "@/components/CreateOrder/TakeDelivery.vue";
import TakePickup from "@/components/CreateOrder/TakePickup.vue";
import TakeExpressDelivery from "@/components/CreateOrder/TakeExpressDelivery.vue";

export default {
  components: { TakePickup, TakeDelivery, TakeExpressDelivery },
  created() {
    this.$store.commit("cart/CHECK_PRODUCTS_FOR_PICKUP_ONLY");
  },
  computed: {
    ...mapState({
      isDelivery: (state) => state.cart.isDelivery,
      isExpressDelivery: (state) => state.cart.isExpressDelivery,
      canPickup: (state) => state.stopList.canPickup,
      canDelivery: (state) => state.stopList.canDelivery,
      cartStopListFlagsLoaded: (state) => state.stopList.cartStopListFlagsLoaded,
      cartProducts: (state) => state.cart.products,
      amount: (state) => state.cart.amount,
      minAmountForDelivery: (state) => state.cart.minAmountForDelivery,
      hasPickupOnlyProducts: (state) => state.cart.hasPickupOnlyProducts,
      allProductsPickupOnly: (state) => state.cart.allProductsPickupOnly,
      yaStopHour: (state) => state.cart.yaDeliveryStopHour,
      yaStartHour: (state) => state.cart.yaDeliveryStartHour,
    }),
    ...mapGetters({
      canProductPickup: 'stopList/canPickupProduct'
    }),
    assertDeliveryMinAmount() {
      return this.amount > this.$store.state.cart.minAmountForDelivery;
    },
    sumCartProducts() {
      return (this.cartProducts || []).reduce(
        (sum, p) => sum + (Number(p.amount) || 0),
        0
      );
    },
    pickupTabMinAmountStub() {
      const min = this.minAmountForDelivery;
      if (min == null || min <= 0) {
        return false;
      }
      return (
        this.cartStopListFlagsLoaded &&
        !this.canPickup &&
        this.canDelivery &&
        this.sumCartProducts < min
      );
    },
    showPickupUnavailableText() {
      return this.cartStopListFlagsLoaded && !this.canPickup;
    },
  },
  methods: {
    ensureDeliveryWhenPickupDisabled() {
      if (!this.cartStopListFlagsLoaded || this.canPickup) {
        return;
      }
      if (!this.isDelivery) {
        this.$store.commit("cart/SET_IS_DELIVERY", true);
        this.$store.commit("cart/SET_IS_EXPRESS_DELIVERY", false);
        this.$store.commit("filial/SET_ACTIVE_FILIAL", {});
        this.$store.commit("cart/RESET_DELIVERY_STATE", {});
      }
    },
    setIsDelivery(isDelivery, isExpressDelivery) {
      this.$store.commit("cart/CHECK_PRODUCTS_FOR_PICKUP_ONLY");
      if (this.$store.state.cart.hasPickupOnlyProducts && isDelivery) {
        this.$emit("scroll-to-cart-block");
        this.$toast.open({
          position: "top-right",
          type: "error",
          message: this.$t("OrderBasket_views_delivery_validation_only_pickup"),
          duration: 3000,
        });
        return;
      }
      this.$store.commit("cart/SET_IS_DELIVERY", isDelivery);
      this.$store.commit("cart/SET_IS_EXPRESS_DELIVERY", isExpressDelivery);
      this.$store.commit("filial/SET_ACTIVE_FILIAL", {});
      this.$store.commit("cart/RESET_DELIVERY_STATE", {});
      // this.$store.commit("cart/SET_SELECTED_DELIVERY_TIME", null);
    },
  },

  mounted() {
    if (this.assertDeliveryMinAmount && !this.allProductsPickupOnly) {
      this.setIsDelivery(true, false);
    }
    if(this.amount > this.$store.state.cart.minAmountForDelivery){
      this.$store.commit("cart/SET_IS_DELIVERY", false);
    }
    this.ensureDeliveryWhenPickupDisabled();
  },

  watch: {
    canPickup() {
      this.ensureDeliveryWhenPickupDisabled();
    },
    cartStopListFlagsLoaded(val) {
      if (val) {
        this.ensureDeliveryWhenPickupDisabled();
      }
    },
    assertDeliveryMinAmount(newValue, oldValue) {
      if (!newValue && this.isDelivery) {
        this.setIsDelivery(false, false);
      }
    },
    amount(){
      this.$store.commit('cart/CHECK_PRODUCTS_FOR_PICKUP_ONLY')
      if(this.allProductsPickupOnly){
       this.setIsDelivery(false, false)
      }
    }
  },
};
</script>

<style lang="sass" scoped>
@import "src/assets/styles-new/colors"
@import "src/assets/styles-new/typography"
@import "src/assets/styles-new/vars"

.tt-delivery-type
  padding-bottom: 32px
  border-bottom: 2px solid $light-gray
  &__pickup-hint
    margin: -24px 0 40px
    font-size: 0.9375rem
    line-height: 1.45
    color: $dark-gray
    max-width: 640px
    @media all and (max-width: $mobile-width)
      margin-top: -16px
      margin-bottom: 24px
  &__tabs
    margin-bottom: 40px
    padding-bottom: 7px
    border-bottom: 2px solid $light-gray
    display: flex
    gap: 72px
    @media all and (max-width: $mobile-width)
      flex-direction: column
  &__tab
    cursor: pointer
    background: none
    border: none
    outline: none
    font-weight: $fw-semibold
    font-size: 1.25rem
    color: $dark-gray
    display: flex
    align-items: center
    justify-content: center
    &:disabled
      cursor: auto
    &--active
      color: $main
      margin-bottom: -9px
      padding-bottom: 8px
      border-bottom: 2px solid $main

.express-delivery-logo
  height: 20px

@media screen and (max-width: $tablet-width)
  .tt-delivery-type
    padding-bottom: 24px
    &__tabs
      margin-bottom: 24px
      gap: 40px

@media screen and (max-width: $mobile-width)
  .tt-delivery-type
    &__tabs
      gap: 24px
  .express-delivery-span
    display: flex
  .express-delivery-logo
    margin-block: auto
</style>
